/**
 * 座位图状态枚举
 *
 * 状态流转：
 * DRAFT -> PUBLISHED（发布）
 * PUBLISHED -> DRAFT（撤回发布）
 */
export enum SeatMapStatus {
  /** 草稿 - 仅管理端可见、可编辑 */
  DRAFT = 'DRAFT',
  /** 已发布 - 小程序端可见、冻结编辑 */
  PUBLISHED = 'PUBLISHED',
}

/** 所有状态值的数组 */
export const SeatMapStatusValues: string[] = Object.values(SeatMapStatus);

/** 状态中文标签映射 */
export const SeatMapStatusLabels: Record<SeatMapStatus, string> = {
  [SeatMapStatus.DRAFT]: '草稿',
  [SeatMapStatus.PUBLISHED]: '已发布',
};

/** 合法的状态流转映射 */
export const SeatMapStatusTransitions: Record<SeatMapStatus, SeatMapStatus[]> = {
  [SeatMapStatus.DRAFT]: [SeatMapStatus.PUBLISHED], // 发布
  [SeatMapStatus.PUBLISHED]: [SeatMapStatus.DRAFT], // 撤回发布
};
